import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, inject, input, output, viewChild } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';

import { ProductContextFacade } from 'ish-core/facades/product-context.facade';
import { LineItemUpdate } from 'ish-core/models/line-item-update/line-item-update.model';
import { ProductView } from 'ish-core/models/product-view/product-view.model';
import { ModalDialogComponent } from 'ish-shared/components/common/modal-dialog/modal-dialog.component';
import { ModalDialogComponent as ModalDialogComponent_1 } from 'ish-shared/components/common/modal-dialog/modal-dialog.component';
import { LineItemEditDialogComponent } from 'ish-shared/components/line-item/line-item-edit-dialog/line-item-edit-dialog.component';

/**
 * The Line Item Edit Component displays an edit-link and edit-dialog.
 */
@Component({
  selector: 'ish-line-item-edit',
  templateUrl: './line-item-edit.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ModalDialogComponent_1, LineItemEditDialogComponent, AsyncPipe, TranslateModule],
})
export class LineItemEditComponent implements OnInit {
  private context = inject(ProductContextFacade);

  readonly modalDialogRef = viewChild<ModalDialogComponent<unknown>>('modalDialog');

  readonly itemId = input.required<string>();
  readonly updateItem = output<LineItemUpdate>();

  product$: Observable<ProductView>;

  ngOnInit() {
    this.product$ = this.context.select('product');
  }

  show() {
    this.modalDialogRef().show();

    this.context.hold(this.context.select('product'), product => {
      this.modalDialogRef().options().confirmDisabled = !product.available;
    });

    this.context.hold(of(this.modalDialogRef().confirmed), () =>
      this.updateItem.emit({
        itemId: this.itemId(),
        sku: this.context.get('sku'),
        quantity: this.context.get('quantity'),
      })
    );
  }
}
